import React from 'react';
import { Field, Modal } from '../../components/ui';

// Add/Edit reminder — desktop. 560px wide: title (Enter saves), then from date ·
// time · Active/Paused on one line, notes last. Logic: useReminders.
export default function ReminderFormDesktop({ vm }) {
  const { editing, form, setF, closeModal, saveReminder } = vm;
  const active = String(form.Active) === '1';
  return (
    <Modal
      className="pp-rem-modal"
      title={editing ? 'Edit Reminder' : 'Add Reminder'}
      onClose={closeModal}
      footer={<>
        <button className="btn light" onClick={closeModal}>Cancel</button>
        <button className="btn primary" onClick={saveReminder}>Save</button>
      </>}
    >
      <label className="field">Title
        <input autoFocus value={form.Title ?? ''} placeholder="Invitation Calls" onChange={e => setF('Title', e.target.value)}
          onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); saveReminder(); } }} />
      </label>
      <div className="pp-row pp-rem-when">
        <Field label="From date" type="date" value={form.StartDate} required onChange={v => setF('StartDate', v)} />
        <Field label="Reminder time" type="time" value={form.ReminderTime} required onChange={v => setF('ReminderTime', v)} />
        <div className="pp-seg-field">Status
          <div className="pp-seg">
            <button type="button" className={active ? 'on' : ''} onClick={() => setF('Active', 1)}>Active</button>
            <button type="button" className={!active ? 'on' : ''} onClick={() => setF('Active', 0)}>Paused</button>
          </div>
        </div>
      </div>
      <Field label="Notes" type="textarea" rows={2} value={form.Notes} onChange={v => setF('Notes', v)} />
    </Modal>
  );
}
